var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "status success"
  }, [_vm.coins_purchased && _vm.imageIndex !== -1 ? _c('img', {
    attrs: {
      "src": ("/assets/images/shop/icons/coins-" + (_vm.imageIndex + 1) + "x.png"),
      "alt": "treasure"
    }
  }) : _vm.gems_purchased && _vm.imageIndex !== -1 ? _c('img', {
    attrs: {
      "src": ("/assets/images/shop/icons/gems-" + (_vm.imageIndex + 1) + "x.png"),
      "alt": "treasure"
    }
  }) : _c('img', {
    attrs: {
      "src": "/assets/images/shop/icons/treasure.png",
      "alt": "treasure"
    }
  }), _c('h3', [_vm._v("Congratulations!")]), _vm.coins_purchased ? _c('p', [_vm._v(" You have successfully purchased " + _vm._s(_vm.coins_purchased) + " coins. ")]) : _vm._e(), _vm.gems_purchased ? _c('p', [_vm._v(" You have successfully purchased " + _vm._s(_vm.gems_purchased) + " gems. ")]) : _vm._e(), _c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    staticClass: "svg-success",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10"
    }
  }, [_c('circle', {
    staticClass: "success-circle-outline",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "11.5"
    }
  }), _c('circle', {
    staticClass: "success-circle-fill",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "11.5"
    }
  }), _c('polyline', {
    staticClass: "success-tick",
    attrs: {
      "points": "17,8.5 9.5,15.5 7,13"
    }
  })])])]), _c('button', {
    staticClass: "btn btn-dark",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.redirectToHome
    }
  }, [_vm._v(" Ok ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }